import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Serviço',
    parent: 'traveiculo',
    path: '/transporte/traservico/:traVeiculoId',
    name: 'traservico',
    component: () => import('@/views/transporte/traservico/CadastroComGrid.vue'),
    meta: {
      permissions: [eTipoPermissao.VEICULOSNOVO_MENU_1100200299],
    },
    goesToMenu: false,
  },
];
